import { gql } from "graphql-tag"

const homeVideosMutation = gql`
  type Mutation {
    addHomeVideo(
      homeVideoAddInput: HomeVideoAddInput!
      newsIds: [ID!]
      homeVideoReviewIds: [ID!]
      storeLinksAddInput: [StoreLinkAddInput]
    ): HomeVideo!

    addHomeVideoQueued(
      homeVideoAddInput: HomeVideoAddInput!
      newsIds: [ID!]
      homeVideoReviewIds: [ID!]
      storeLinksAddInput: [StoreLinkAddInput]
    ): HomeVideoAddResponse!

    generateScreenshotMetadataField(
      generateScreenshotMetadataFieldInput: GenerateScreenshotMetadataFieldInput!
    ): ScreenshotMetadataFieldResponse!

    updateHomeVideo(
      id: ID!
      homeVideoUpdateInput: HomeVideoUpdateInput!
      storeLinksUpdateInput: [StoreLinkUpdateInput]
    ): HomeVideo!

    deleteHomeVideo(id: ID!): DeleteResponse!
  }
`

export default homeVideosMutation
